module.exports = __webpack_public_path__ + "img/zhxy_image_5.1636aa0f.png";